import { carouselItems } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          焦点专题
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden bg-background-50 group cursor-pointer min-h-[280px] md:min-h-[300px]"
            >
              <img
                src={item.img}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-white/80 leading-relaxed max-w-[500px]">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}